/* ============================================================
   Cart: Rush Creation removal intercept
   The × on a rush line no longer deletes — it opens a
   creation-speed modal whose only exits are a valid state
   (pick a replacement tier or keep the current one). Works on
   both the cart page and the cart drawer.

   Pure logic mirrors scripts/cart-rush/rush-intercept.mjs
   (theme assets are unbundled and cannot import). Keep in sync.
   ============================================================ */
(function () {
  'use strict';

  var STANDARD_ATTRIBUTE_VALUE = 'standard_8_week';

  // Pure helpers mirrored from scripts/cart-rush/rush-intercept.mjs.
  function computeReadyToShip(weeks, today) {
    var wk = Number(weeks);
    if (!isFinite(wk)) return '';
    var d = new Date((today || new Date()).getTime());
    d.setDate(d.getDate() + Math.round(wk * 7));
    var locale = (window.Shopify && window.Shopify.locale) || 'en-US';
    try {
      return d.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
  }

  function priceDelta(fromPrice, toPrice) {
    var from = Number(fromPrice) || 0;
    var to = Number(toPrice) || 0;
    return Math.round((to - from) * 100) / 100;
  }

  function analyticsTierCode(tier) {
    if (!tier) return '';
    var prefix = tier.isStandard ? 'standard_' : '';
    if (isFinite(tier.weeks) && tier.weeks > 0) return prefix + tier.weeks + '_week';
    if (tier.isStandard) return 'standard_8_week';
    var label = String(tier.label || '');
    var m = label.match(/(\d+)\s*week/i);
    if (m) return m[1] + '_week';
    return label.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function tierDisplayName(tier) {
    if (!tier) return '';
    var hasWeeks = isFinite(tier.weeks) && tier.weeks > 0;
    if (tier.isStandard) {
      return hasWeeks
        ? tier.weeks + ' ' + s('weekStandard', 'Week Standard Creation')
        : s('standardLabel', 'Standard Creation');
    }
    return hasWeeks ? tier.weeks + ' ' + s('weekRush', 'Week Rush Creation') : String(tier.label || 'Rush Creation');
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function changeUrl() {
    return typeof routes !== 'undefined' && routes.cart_change_url
      ? routes.cart_change_url + '.js'
      : '/cart/change.js';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.text().then(function (t) {
        var json = {};
        try {
          json = t ? JSON.parse(t) : {};
        } catch (e) {
          json = {};
        }
        if (!r.ok) {
          var err = new Error((json && (json.description || json.message)) || 'Cart request failed');
          err.cart = json;
          throw err;
        }
        return json;
      });
    });
  }

  function getCartPageSection() {
    return document.querySelector('.main-cart-section');
  }

  function getCartPageSectionId() {
    var el = getCartPageSection();
    if (!el) return null;
    // The Section Rendering API needs the clean section id (no "shopify-section-"
    // prefix). Prefer the inner element's data-section-id; else strip the prefix.
    var inner = el.querySelector('[data-section-id]');
    var id = (inner && inner.getAttribute('data-section-id')) || String(el.id || '').replace(/^shopify-section-/, '');
    return id || null;
  }

  function money(cents) {
    var n = Number(cents) || 0;
    return '$' + (n / 100).toFixed(2);
  }

  function tierConfigForRow(row) {
    var currentVariantId = row.getAttribute('data-cc-variant-id');
    // Preferred: global tier map keyed by rush product id (works on both surfaces,
    // incl. the drawer which rebuilds its rows in JS).
    var pid = row.getAttribute('data-cc-product-id');
    if (pid && window.ccRushintTiers && window.ccRushintTiers[pid] && window.ccRushintTiers[pid].tiers) {
      return { tiers: window.ccRushintTiers[pid].tiers, currentVariantId: currentVariantId };
    }
    // Fallback: <script> blob rendered inside the cart-page rush row.
    var blob = row.querySelector('.cc-rushint-tiers');
    if (!blob) {
      var lk = row.getAttribute('data-cc-line-key');
      if (lk) {
        var esc = window.CSS && CSS.escape ? CSS.escape(lk) : lk.replace(/"/g, '\\"');
        blob = document.querySelector('.cc-rushint-tiers[data-cc-line-key="' + esc + '"]');
      }
    }
    if (!blob) return null;
    try {
      return JSON.parse(blob.textContent);
    } catch (e) {
      return null;
    }
  }

  function findCurrentTier(config, currentVariantId) {
    if (!config || !config.tiers) return null;
    var vid = currentVariantId == null ? null : String(currentVariantId);
    for (var i = 0; i < config.tiers.length; i++) {
      if (config.tiers[i].id != null && String(config.tiers[i].id) === vid) return config.tiers[i];
    }
    return null;
  }

  function refreshReadyChips(scope) {
    var root = scope || document;
    var rows = root.querySelectorAll('[data-cc-rushint-line]');
    Array.prototype.forEach.call(rows, function (row) {
      try {
        var config = tierConfigForRow(row);
        var current = findCurrentTier(config, row.getAttribute('data-cc-variant-id'));

        // Speed line: "2 Week Rush · for {pet}'s clone above"
        var speedText = row.querySelector('[data-cc-speed-text]');
        if (speedText && current) {
          var line = tierDisplayName(current);
          var pet = row.getAttribute('data-cc-pet-name');
          if (pet) {
            line += ' ' + decodeEntities(s('petCloneLine', "· for {pet}'s clone above")).replace('{pet}', pet);
          }
          speedText.textContent = line;
        }

        var chip = row.querySelector('[data-cc-ready-chip]');
        var text = row.querySelector('[data-cc-ready-text]');
        if (!chip || !text) return;
        var weeks = current ? current.weeks : null;
        if (weeks == null) {
          chip.hidden = true;
          return;
        }
        var date = computeReadyToShip(weeks);
        if (!date) {
          chip.hidden = true;
          return;
        }
        text.textContent = s('readyPrefix', 'Ready to ship on ') + date;
        chip.hidden = false;
      } catch (e) {
        /* one bad row must not block the others */
      }
    });
  }

  var modalCtx = null;

  function els() {
    return {
      overlay: document.querySelector('[data-cc-rushint-overlay]'),
      dialog: document.querySelector('[data-cc-rushint-dialog]'),
      group: document.querySelector('[data-cc-rushint-tiergroup]'),
      sub: document.querySelector('[data-cc-rushint-sub]'),
      confirm: document.querySelector('[data-cc-rushint-confirm]'),
      keep: document.querySelector('[data-cc-rushint-keep]'),
    };
  }

  function s(key, fallback) {
    return (window.ccRushintStrings && window.ccRushintStrings[key]) || fallback;
  }

  // Shopify's `t` filter HTML-escapes strings (e.g. ' -> &#39;); decode for textContent.
  function decodeEntities(str) {
    if (!str || str.indexOf('&') === -1) return str;
    var ta = document.createElement('textarea');
    ta.innerHTML = str;
    return ta.value;
  }

  function renderTiers() {
    var e = els();
    if (!e.group || !modalCtx) return;
    var current = modalCtx.currentTier;
    e.group.innerHTML = '';

    modalCtx.config.tiers.forEach(function (tier) {
      var isCurrent = current && tier.id != null && String(tier.id) === String(current.id);
      var checked = modalCtx.pendingKey === tierKey(tier);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-rushint-tier';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', checked ? 'true' : 'false');
      btn.setAttribute('data-cc-tier-key', tierKey(tier));

      var radio = document.createElement('span');
      radio.className = 'cc-rushint-radio';
      radio.setAttribute('aria-hidden', 'true');

      var mid = document.createElement('span');
      var name = document.createElement('span');
      name.className = 'cc-rushint-tier-name';
      name.textContent = tierDisplayName(tier);
      if (isCurrent) {
        var badge = document.createElement('span');
        badge.className = 'cc-rushint-tier-badge';
        badge.textContent = s('currentBadge', 'Current');
        name.appendChild(document.createTextNode(' '));
        name.appendChild(badge);
      }
      var eta = document.createElement('span');
      eta.className = 'cc-rushint-tier-eta';
      var date = computeReadyToShip(tier.weeks);
      eta.innerHTML = date
        ? s('readyPrefix', 'Ready to ship on ') + '<strong>' + date + '</strong>'
        : '';
      mid.appendChild(name);
      mid.appendChild(eta);

      var price = document.createElement('span');
      price.className = 'cc-rushint-tier-price';
      if (tier.isStandard || Number(tier.price) === 0) {
        price.innerHTML = '<span class="cc-rushint-free">' + s('free', 'FREE') + '</span>';
      } else {
        price.textContent = '+' + (tier.priceFormatted || money(Number(tier.price) * 100));
      }

      btn.appendChild(radio);
      btn.appendChild(mid);
      btn.appendChild(price);
      btn.addEventListener('click', function () {
        modalCtx.pendingKey = tierKey(tier);
        renderTiers();
      });
      e.group.appendChild(btn);
    });

    if (e.keep && current) {
      e.keep.textContent = s('keepPrefix', 'Keep ') + tierDisplayName(current);
    }
  }

  function tierKey(tier) {
    return 'v' + String(tier.id);
  }

  function pendingTier() {
    if (!modalCtx) return null;
    var list = modalCtx.config.tiers;
    for (var i = 0; i < list.length; i++) {
      if (tierKey(list[i]) === modalCtx.pendingKey) return list[i];
    }
    return null;
  }

  function openModal(row, source) {
    var config = tierConfigForRow(row);
    var e = els();
    if (!e.overlay || !e.dialog) return;

    if (!config || !config.tiers || !config.tiers.length) {
      // Never allow a silent delete: keep the line, ask the user to retry.
      showToast(s('reloadError', 'Could not load creation-speed options. Please refresh and try again.'));
      return;
    }

    var currentVariantId = row.getAttribute('data-cc-variant-id');
    var current = findCurrentTier(config, currentVariantId) || config.tiers[0];

    modalCtx = {
      surface: row.getAttribute('data-cc-surface') || 'page',
      lineKey: row.getAttribute('data-cc-line-key'),
      key: row.getAttribute('data-cc-plush-key'),
      currentVariantId: currentVariantId,
      config: config,
      currentTier: current,
      pendingKey: tierKey(current),
      source: source,
      trigger: document.activeElement,
    };

    if (e.sub) {
      e.sub.textContent = s(
        'subtitle',
        'Every order includes a creation speed so our artisans know when to have your clone ready. Choose a replacement — Standard is always free.'
      );
    }
    renderTiers();

    e.overlay.hidden = false;
    document.body.classList.add('cc-rushint-open');
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(e.dialog, e.confirm);
    } else if (e.confirm) {
      e.confirm.focus();
    }

    pushDataLayer({ event: 'rush_modal_opened', source: source });
  }

  function closeModal(returnFocus) {
    var e = els();
    if (!e.overlay) return;
    e.overlay.hidden = true;
    document.body.classList.remove('cc-rushint-open');
    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(returnFocus && modalCtx ? modalCtx.trigger : null);
    } else if (returnFocus && modalCtx && modalCtx.trigger && modalCtx.trigger.focus) {
      modalCtx.trigger.focus();
    }
  }

  function dismiss(method) {
    pushDataLayer({ event: 'rush_modal_dismissed', method: method });
    closeModal(true);
    modalCtx = null;
  }

  function showToast(msg) {
    var toast = document.querySelector('[data-cc-rushint-toast]');
    var span = document.querySelector('[data-cc-rushint-toast-msg]');
    if (!toast || !span) return;
    span.textContent = msg;
    toast.hidden = false;
    // force reflow so the transition runs
    void toast.offsetWidth;
    toast.classList.add('cc-rushint-toast--show');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      toast.classList.remove('cc-rushint-toast--show');
      setTimeout(function () {
        toast.hidden = true;
      }, 400);
    }, 3400);
  }

  function rerenderCartPage(cartResponse) {
    var sectionId = getCartPageSectionId();
    if (!sectionId || !cartResponse || !cartResponse.sections || !cartResponse.sections[sectionId]) {
      return false;
    }
    var parsed = new DOMParser().parseFromString(cartResponse.sections[sectionId], 'text/html');
    var newSection = parsed.getElementById(sectionId);
    if (!newSection) return false;

    var pairs = [
      ['[data-line-items-container]', '[data-line-items-container]'],
      ['[data-render-cart-totals]', '[data-render-cart-totals]'],
    ];
    pairs.forEach(function (pair) {
      var target = document.querySelector(pair[0]);
      var source = newSection.querySelector(pair[1]);
      if (target && source) target.innerHTML = source.innerHTML;
    });
    return true;
  }

  function syncSharedState(cartResponse) {
    if (window.VanillaCartState && typeof window.VanillaCartState.updateCart === 'function') {
      window.VanillaCartState.updateCart(cartResponse);
    } else {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartResponse, bubbles: true }));
    }
  }

  function performSwap() {
    var pending = pendingTier();
    if (!pending || !modalCtx) return;

    var current = modalCtx.currentTier;
    var unchanged = tierKey(pending) === tierKey(current);
    if (unchanged) {
      closeModal(true);
      modalCtx = null;
      return;
    }

    var e = els();
    if (e.confirm) e.confirm.setAttribute('aria-busy', 'true');

    var lineKey = modalCtx.lineKey;
    var uniqueKey = modalCtx.key;
    var sectionId = getCartPageSectionId();
    var useAttributeStandard = pending.isStandard && pending.id == null;

    // Add the replacement (or write the attribute) BEFORE removing the old line,
    // so the order never momentarily lacks a creation-speed signal.
    var prep;
    if (useAttributeStandard) {
      prep = postJSON('/cart/update.js', { attributes: { creation_speed: STANDARD_ATTRIBUTE_VALUE } });
    } else {
      prep = postJSON('/cart/add.js', {
        id: pending.id,
        quantity: 1,
        properties: { _rush_product: 'true', _unique_key: uniqueKey },
      });
    }

    prep
      .then(function () {
        // Remove the old rush line last, requesting the cart-page section HTML.
        var body = { id: lineKey, quantity: 0 };
        if (sectionId) {
          body.sections = [sectionId];
          body.sections_url = window.location.pathname;
        }
        return postJSON(changeUrl(), body);
      })
      .then(function (cartResponse) {
        rerenderCartPage(cartResponse);
        syncSharedState(cartResponse);
        refreshReadyChips(document);

        var delta = priceDelta(current.price, pending.price);
        pushDataLayer({
          event: 'rush_tier_changed',
          rush_from: analyticsTierCode(current),
          rush_to: analyticsTierCode(pending),
          price_delta: delta,
          source: modalCtx ? modalCtx.source : undefined,
        });

        var date = computeReadyToShip(pending.weeks);
        showToast(
          s('updatedPrefix', 'Creation speed updated to ') +
            tierDisplayName(pending) +
            (date ? ' — ' + s('readyPrefixLower', 'ready to ship on ') + date : '')
        );

        closeModal(false);
        modalCtx = null;
      })
      .catch(function (err) {
        if (err && err.zipperBlocked) {
          closeModal(true);
          modalCtx = null;
          return;
        }
        showToast(s('genericError', 'Something went wrong. Please try again.'));
      })
      .then(function () {
        if (e.confirm) e.confirm.removeAttribute('aria-busy');
      });
  }

  function isRushRemoveClick(target) {
    var btn = target.closest && target.closest('.line-item_remove-btn, .cart-item-remove-btn');
    if (!btn) return null;
    var row = btn.closest('[data-cc-rushint-line]');
    return row || null;
  }

  // Capture phase so we run BEFORE the section's own remove handlers.
  document.addEventListener(
    'click',
    function (e) {
      var row = isRushRemoveClick(e.target);
      if (row) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openModal(row, 'x_button');
        return;
      }
      var changeLink = e.target.closest && e.target.closest('[data-cc-rushint-change]');
      if (changeLink) {
        var changeRow = changeLink.closest('[data-cc-rushint-line]');
        if (changeRow) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openModal(changeRow, 'change_link');
        }
      }
    },
    true
  );

  // Modal controls (bubble phase — inside our own modal).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cc-rushint-confirm]')) {
      performSwap();
      return;
    }
    if (e.target.closest && e.target.closest('[data-cc-rushint-keep]')) {
      dismiss('keep_button');
      return;
    }
    var overlay = document.querySelector('[data-cc-rushint-overlay]');
    if (overlay && e.target === overlay) {
      dismiss('backdrop');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var overlay = document.querySelector('[data-cc-rushint-overlay]');
    if (overlay && !overlay.hidden) {
      e.preventDefault();
      dismiss('esc');
    }
  });

  function init() {
    refreshReadyChips(document);
    // Catch late renders (e.g. the drawer hydrates its rows from /cart.js after load).
    requestAnimationFrame(function () {
      refreshReadyChips(document);
    });
    setTimeout(function () {
      refreshReadyChips(document);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-fill ready chips after any cart re-render.
  document.addEventListener('cart:updated', function () {
    setTimeout(function () {
      refreshReadyChips(document);
    }, 0);
  });
})();
